import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBack$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBack extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e1026e28f9469e1692e420e5dfd2aad5a15b990b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e0bec327786e8246bcc3ca5c1fb02f43984f745e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a56c8a520ad3578330e70cd94b87294bd533e59a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9 10.25V6.72a.3.3 0 0 0-.51-.21l-4.28 4.28a.29.29 0 0 0 0 .42l4.28 4.28a.3.3 0 0 0 .51-.21v-3.53h9.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-back", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-back"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-back":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBack$1);
            }
            break;
    } });
}

const CosmosIconBack = CosmosIconBack$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBack, defineCustomElement };
